import React, { useEffect } from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Contact from "@/components/Contact";
import ServiceArea from "@/components/ServiceArea";

export default function ContactPage() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main data-testid="contact-page" className="relative bg-[var(--paper)]">
            <Nav />
            <header className="pt-32 md:pt-40 pb-12 md:pb-16 border-b border-line">
                <div className="maxw section-pad">
                    <div className="eyebrow mb-5">Get a free quote</div>
                    <h1 className="font-display font-light text-5xl sm:text-6xl md:text-7xl leading-[0.98] tracking-tight max-w-4xl">
                        Tell us what needs doing — we’ll{" "}
                        <span className="italic text-[var(--terra)]">
                            reply within a day
                        </span>
                        .
                    </h1>
                </div>
            </header>
            <Contact />
            <ServiceArea />
            <Footer />
        </main>
    );
}
